import React from "react";
import { Quote } from "lucide-react";
import Reveal from "./Reveal";

const Testimonials = () => {
  return (
    <section className="relative py-20 lg:py-24">
      <div className="max-w-4xl mx-auto px-5 lg:px-8">
        <Reveal>
          <div className="rounded-2xl border border-dashed border-[#29354A] bg-[#0A1220] p-10 lg:p-14 text-center">
            <span className="inline-flex w-12 h-12 rounded-full bg-[#10C98A]/12 items-center justify-center mb-5">
              <Quote className="w-5 h-5 text-[#13D99A]" />
            </span>
            <h2 className="font-display text-2xl lg:text-3xl font-bold text-[#F5F7FB]">Beta stories coming soon.</h2>
            <p className="mt-3 text-[#8290A8] max-w-md mx-auto">
              Real, approved stories from beta testers will appear here as our private beta grows.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default Testimonials;
